<div class="date-picker-wrapper">
  <!-- Native hidden date input -->
  <input
    type="date"
    #datePicker
    [min]="minDateFormatted"
    [max]="maxDateFormatted"
    [disabled]="disabled"
    (change)="onDateSelected($event)"
    class="real-date-input"
  />

  <!-- Visible input wrapper -->
  <div class="input-wrapper" [class.has-error]="errorMessage">
    <input
      type="text"
      #fakeInput
      class="fake-date-input"
      [value]="displayValue"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readOnly"
      [style.backgroundColor]="(disabled || readOnly) ? '#f3f4f6' : backgroundColor"
      [style.cursor]="readOnly ? 'not-allowed' : 'text'"
      (input)="onManualInput($event)"
      (blur)="onManualInputBlur($event)"
      (focus)="onFocus()"
      maxlength="10"
    />

    <span
      class="calendar-icon"
      [class.disabled]="readOnly || disabled"
      (click)="openDatePicker()"
      title="فتح التقويم"
    >
      📅
    </span>
  </div>

  <!-- Error message -->
  <div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>